import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataGridColDef } from './DataGrid/DataGrid';
import {
  PropElemScheduleResponse,
  PropElementResponse,
} from '../services/proposal';
import { toCoef, toCurrency, toRate } from '../utils/utils';
import ModalControllerNV from './ModalControllerNV';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import {
  Tabs,
  Table,
  Typography,
  Badge,
  Card,
  Row,
  Col,
  InputNumber,
  Divider,
  Spin,
} from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import _, { sumBy } from 'lodash';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import DataGrid from './theme_components/DataGrid';

const { TabPane } = Tabs;
const { Text } = Typography;
const { Cell } = Table.Summary;
export type FinancialScheduleTableProps = {
  finElement: PropElementResponse;
  currcode?: string;
  phase?: string;
  loading?: boolean;
  flagretailer?: boolean;
};

const FinancialScheduleTable = (props: FinancialScheduleTableProps) => {
  const { finElement, currcode, phase, loading, flagretailer } = props;

  const { t } = useTranslation();

  const { getComponentConfiguration } = useDisplayFrameworkContext();

  const compHide = (comcode: string): boolean => {
    let comp = getComponentConfiguration(comcode);
    return comp?.flaghide ?? false;
  };

  const COLUMNS: DataGridColDef<PropElemScheduleResponse>[] = [
    {
      dataIndex: 'ctsorder',
      width: 40,
      fixed: 'left',
    },
    {
      dataIndex: 'ctstype',
      render: (val) => {
        let _val = val;
        if (flagretailer) {
          _val = val === 'RENTAL' ? 'GRACE' : val === 'RV' ? 'CAPITAL' : val;
        }
        return _val;
      },

      width: 70,
      fixed: 'left',
    },
    {
      dataIndex: 'ctsduedate',
      width: 90,
      fixed: 'left',
    },
    {
      dataIndex: 'ctsstartamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      comcode: 'ctsvatdeffered',
      dataIndex: 'ctsvatdeffered',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },

    {
      dataIndex: 'ctsamortizedamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsinterestamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsoutstandingamount',
      render: (text, record) =>
        toCurrency(text, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsdiscountcoef',
      render: (text, record) => (text !== undefined ? toCoef(text) : 0),
      width: 120,
    },

    {
      dataIndex: 'ctsdiscountoutstanding',
      render: (text, record) =>
        toCurrency(text, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsdiscountinterest',
      render: (text, record) =>
        toCurrency(text, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsagiosdeb',
      render: (text, record) =>
        toCurrency(text, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsdiscountagiosdeb',
      render: (text, record) =>
        toCurrency(text, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },

    {
      dataIndex: 'ctsrentalamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsdepositbasis',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },
    {
      dataIndex: 'ctsdepositinterest',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },

    {
      dataIndex: 'ctstaxamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
    },

    {
      dataIndex: 'ctsstartdate',
      width: 120,
    },
    {
      dataIndex: 'ctsenddate',
      width: 120,
    },
    {
      dataIndex: 'ctsstatus',
      width: 120,
    },
    {
      dataIndex: 'cireference',
      render: (value, record) => {
        return (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <CIDetail
                ciid={record.ciid}
                onCancel={() => setVisible(false)}
                showAsModal
                visible={visible}
                showButtons={false}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        );
      },
      width: 120,
    },
    {
      key: 'ctsrentalincDeposit',
      render: (_, record: any) =>
        toCurrency(
          record.ctsrentalamount - record.ctsdepositinterest,
          currcode ?? localStorage.getItem('currcode') ?? ''
        ),
      width: 100,
      fixed: 'right',
    },
    {
      dataIndex: 'ctstotalamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 120,
      fixed: 'right',
    },
  ];
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Spin spinning={loading}>
        {/* <Tabs type="card" style={{ height: '800px' }}>
          {!compHide('paymentSchedule') && (
            <TabPane
              forceRender
              tab={
                <Badge style={{ backgroundColor: '#52c41a' }}>
                  <GetLabel label="paymentSchedule" />
                </Badge>
              }
              key="1"
            >
             
            </TabPane>
          )}
          {/* {!compHide('Cost of Fund & Margin Analysis') && (
            <TabPane
              forceRender
              tab={
                <Badge style={{ backgroundColor: '#52c41a' }}>
                  <GetLabel label="Cost of Fund & Margin Analysis" />
                </Badge>
              }
              key="2"
              style={{ fontSize: 16 }}
            >
              <Card type="inner">
                <Row gutter={8}>&nbsp;</Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Funding Rate&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <InputNumber
                      size="middle"
                      value={finElement?.ctefundingrate}
                    />
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    Funding Periodicity&nbsp;{' '}
                  </Col>
                  <Col span={7}>{finElement?.ctefundingperiodicity}</Col>
                </Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Installment amount &nbsp;{' '}
                  </Col>
                  <Col span={7}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.ctefundinginstallment,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                </Row>
                <Divider>Margin Analysis</Divider>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    invest Amount&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.cteinvestamount,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    Customer Rate&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toRate(finElement?.ctenominalrate)}
                    </Text>
                    &nbsp;
                    <Text>{finElement?.cteratetype}</Text>
                  </Col>
                </Row>

                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Interest&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.totalInterest,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Rental Payment&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.totalRental,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                </Row>

                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Fees&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.ctefeesamount,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    APR&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">{toRate(finElement?.cteaprrate)}</Text>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Participation&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.ctepartamount,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Flat Rate&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">{toRate(finElement?.cteflatrate)}</Text>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Commission&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.ctecommissionamount,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    Rate/000&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">{toRate(finElement?.ctecoefrate)}</Text>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Profitability Amount before Funding&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.profitabilityAmount,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Profitability Rate Before Funding&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toRate(finElement?.cteprofitabilityrate)}
                    </Text>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    total Cost of Fund&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        sumBy(
                          finElement?.fundingSchedule,
                          'ctsinterestamount'
                        ) ?? 0,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                </Row>

                <Row gutter={8}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Net Margin&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toCurrency(
                        finElement?.profitabilityAmount -
                          sumBy(
                            finElement?.fundingSchedule,
                            'ctsinterestamount'
                          ) ?? 0,
                        finElement?.currcode
                      )}
                    </Text>
                  </Col>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    Margin Rate&nbsp;{' '}
                  </Col>
                  <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                    <Text type="danger">
                      {toRate(
                        finElement?.cteprofitabilityrate -
                          finElement?.ctefundingrate
                      )}
                    </Text>
                  </Col>
                </Row>
              </Card>
            </TabPane>
          )} */}

        <DataGrid
          dataSource={finElement?.conElemSchedules}
          columns={
            phase !== 'PROD'
              ? COLUMNS.filter(
                  (ele) =>
                    ele.dataIndex !== 'cireference' &&
                    ele.dataIndex !== 'ctsstatus'
                )
              : COLUMNS
          }
          rowKey={(record) => record.ctsorder}
          scroll={{ x: 1000, y: 360 }}
          pagination={{ pageSize: 200 }}
          scrollInput={{ x: 1000, y: 700 }}
          extractData="paymentSchedule"
          extraActions={undefined}
          hideMarginExtractData
        
        />
      </Spin>
    </div>
  );
};

export default FinancialScheduleTable;
